import React, { FC, useEffect, useState } from 'react';

import { AlertHistoryBy } from '@ariksa/notification';
import { Box } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';

import { usePageContentContext } from 'components/Layout';
import { Tour } from 'components/Tour';
import { userDashboard } from 'components/Tour/Steps/dashboard';
import { useAccessBoundary } from 'containers/App/hooks/useAccessBoundary';
import {
  selectActiveCloudAccount,
  selectActiveEnvironment,
} from 'containers/App/selectors';
import { FindingsContextProvider } from 'containers/Findings/FindingsOverview/Components/hooks/FindingsContext';
import { selectFindingsOverview } from 'containers/Findings/FindingsOverview/selectors';
import { selectSharedState } from 'containers/SharedState/selectors';
import { actions as sharedStateActions } from 'containers/SharedState/slice';

import { FindingsOverviewSideNav } from './Components/AlertTables/Components/FindingsOverviewSideNav';
import { actions } from './slice';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

export const FindingsOverview: FC = () => {
  const dispatch = useDispatch();
  const { accountId } = useSelector(selectActiveCloudAccount);
  const { environmentId } = useSelector(selectActiveEnvironment);
  const { withAccessBoundary } = useAccessBoundary();
  const { currentCategory } = useSelector(selectFindingsOverview);
  const { aiParamExtraction } = useSelector(selectSharedState);
  const [refresh, setRefresh] = useState(false);
  const toggleRefresh = () => setRefresh(!refresh);
  const { contentHeight } = usePageContentContext();

  //load alert categories
  useEffect(() => {
    if (!!environmentId || !!accountId) {
      dispatch(
        sharedStateActions.getAlertCategories({
          q: { accountId, environmentId },
        }),
      );
      dispatch(
        actions.loadAlertCategories({ q: { accountId, environmentId } }),
      );
    }
  }, [dispatch, accountId, environmentId]);

  useEffect(() => {
    if (!!environmentId || !!accountId) {
      const alertCategory =
        currentCategory === 'Overview' || currentCategory === 'AllFindings'
          ? undefined
          : (currentCategory as string);
      const endDate = aiParamExtraction.data?.end_date
        ? dayjs(aiParamExtraction.data?.end_date).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD');

      const startDate = aiParamExtraction.data?.start_date
        ? dayjs(aiParamExtraction.data?.start_date).format('YYYY-MM-DD')
        : dayjs().subtract(6, 'day').format('YYYY-MM-DD');

      dispatch(
        actions.loadAlertHistoryByTrend({
          q: withAccessBoundary({
            startDate,
            endDate,
            historyBy: AlertHistoryBy.Trend,
            alertCategory,
          }),
        }),
      );
      dispatch(
        actions.loadAlertHistoryByStatus({
          q: withAccessBoundary({
            startDate,
            endDate,
            historyBy: AlertHistoryBy.Status,
            alertCategory,
          }),
        }),
      );
    }
  }, [
    dispatch,
    withAccessBoundary,
    accountId,
    environmentId,
    currentCategory,
    aiParamExtraction.data,
  ]);

  //get alert resource types
  useEffect(() => {
    dispatch(sharedStateActions.getAlertResourceTypes({ q: {} }));
  }, [dispatch]);

  return (
    <>
      <Tour steps={userDashboard} fieldName="userDashboardTour">
        <Box key={'1'} h={contentHeight - 8 + 'px'} overflow="hidden">
          <FindingsContextProvider
            value={{
              refresh,
              toggleRefresh,
            }}
          >
            <FindingsOverviewSideNav />
          </FindingsContextProvider>
        </Box>
      </Tour>
    </>
  );
};
